import ErrorIcon from '@mui/icons-material/ErrorOutline';
import SearchIcon from '@mui/icons-material/Search';
import { MenuItem, Select } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { useGridApiRef } from '@mui/x-data-grid';
import React, { useCallback, useEffect, useReducer, useState } from 'react';
import { toast } from 'react-toastify';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { GenericMessageDialog } from '../Common/Components/GenericMessageDialog';
import { MUIButton } from '../Common/Components/MuiButton';
import { Constants } from '../Common/Constants';
import ServerExportWrapper from '../Common/DataGridServerExportWrapper';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { defaultStringIfNullOrEmpty, downloadInvoiceFile, formatDate, formatNumber, getFileIcon, getFilter, getInvoiceModuleName, setFilter, toNumberWithNoDecimalPlaces } from '../Common/Utilities';
import { InvoiceDocumentEditor } from './InvoiceDocumentEditor';
import { isNewUi } from '../../redesign/uiMode';
import { arrangeListColumns } from '../../redesign/lists/invoiceList';


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});


const filterFunction = (state, action) => {
	return {
		...state,
		...action.payload
	}
}

const dataPayload = {
	data: [],
	hasUnarchivePermission: false,
	statusList: [],
	initialLoad: false
}
const dataAction = (state, action) => {
	return {
		...state,
		...action.payload
	}
}

const exportPayload = {
	tempTableEnabled: false,
	dataLoaded: false,
	exportData: [],
	statusList: []
}
const exportAction = (state, action) => {
	return {
		...state,
		...action.payload
	}
}
// #region old component
const ArchivedInvoiceDocument = ({ inProgress, modelDefId }) => {

	const mainGridRef = useGridApiRef();
	const baseSessionPath = [getInvoiceModuleName(modelDefId), 'ArchivedInvoiceDocuments'];
	const storedText = getFilter([...baseSessionPath, 'searchText']) || '';
	const storedWeeks = parseInt(getFilter([...baseSessionPath, 'weeksToFilter']), 10);
	const storedSortModel = getFilter([...baseSessionPath, 'sortModel']) || [];
	const normalizedWeeks = isNaN(storedWeeks) ? 9 : storedWeeks;


	const filterPayload = {
		weeksToFilter: normalizedWeeks,
		filterText: storedText,
		sortModel: storedSortModel,
		previousSearchText: (normalizedWeeks === 0 && storedText?.trim()) ? storedText : '',
		isServerMode: normalizedWeeks === 0
	};


	const [filterState, filterDispatch] = useReducer(filterFunction, filterPayload);
	const [viewData, dataDispatch] = useReducer(dataAction, dataPayload);
	const [exportState, setExportState] = useReducer(exportAction, exportPayload);
	const [openInvoiceDocumentEditorDialog, setOpenInvoiceDocumentEditorDialog] = useState(false);
	const [viewRowData, setViewRowData] = useState({});
	const [mode, setMode] = useState(null);
	const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
	const [downloadingInvoices, setDownloadingInvoices] = useState({});

	const serverProps = filterState.isServerMode ? { filterMode: 'server' } : {};

	const handleDownloadFile = (modelDefId, invoiceDocumentId, fileLocation) => {

		setDownloadingInvoices(prev => ({
			...prev,
			[invoiceDocumentId]: true
		}));

		downloadInvoiceFile(modelDefId, fileLocation)
			.catch((error) => {

				const isNotFoundError =
					error?.response?.status === 422 ||
					error?.message === 'FILE_NOT_FOUND';

				if (isNotFoundError) {
					toast.error('File not found.');
				} else {
					toast.error('Failed to download the file.');
				}
			})
			.finally(() => {

				setDownloadingInvoices(prev => {
					const next = { ...prev };
					delete next[invoiceDocumentId];
					return next;
				});
			});
	};


	const fetchArchivedInvoices = useCallback((search = '', weekFilter = 9) => {
		const url = `/api/invoicedocument/${modelDefId}/archivedinvoices?searchFilter=${encodeURIComponent(search)}&weeksToFilter=${weekFilter}`;
		inProgress(true);
		httpGet(url)
			.then((res) => {
				const newData = (res.data?.listOfItems || []).map((e, i) => ({ ...e, rowId: i }));
				const canUnArchive = res.data?.ruleSet[0] || false;
				dataDispatch({ payload: { data: newData, hasUnarchivePermission: canUnArchive, initialLoad: true } });

				if (weekFilter === 0 && search.trim() !== '') {
					filterDispatch({
						payload: {
							previousSearchText: search
						}
					});
				}
				inProgress(false);
			})
			.catch(() => {
				toast.error('Error fetching archived invoices');
				inProgress(false);
			});
	}, [inProgress, modelDefId]);
	const fetchArchivedInvoiceReport = useCallback((modelDefId, invoiceDocumentIds) => {
		const url = `/api/invoicedocument/${modelDefId}/archivedinvoices/export`;
		inProgress(true);
		httpPost(url, {
			otherFilters: invoiceDocumentIds,
			modelDefId: modelDefId
		}).then((res) => {
			const newData = (res.data?.listOfItems || []).map((e, i) => ({ ...e, rowId: i }));
			const statusList = res.data?.ruleSet[0] || []
			setExportState({ payload: { exportData: newData, statusList: statusList, dataLoaded: true, tempTableEnabled: true } });
			inProgress(false);
		})
			.catch(() => {
				toast.error('Error: Export failed');
				inProgress(false);
			});

	}, [inProgress, modelDefId]);

	useEffect(() => {
		const isNoFilter = filterState.weeksToFilter === 0;
		mainGridRef?.current.setQuickFilterValues([filterState.filterText]);
		fetchArchivedInvoices(isNoFilter ? filterState.filterText : '', filterState.weeksToFilter);

	}, [fetchArchivedInvoices, filterState.weeksToFilter]);
	React.useEffect(() => {

		if (filterState.filterText && viewData.initialLoad) {
			mainGridRef.current.setQuickFilterValues([filterState.filterText]);
			mainGridRef.current.forceUpdate();
		}
	}, [viewData.initialLoad, mainGridRef])

	const modelDefName = React.useMemo(() => {
		return {
			1: 'Media',
			2: 'Production',
			3: 'Broadcast'
		}
	}, [])

	const isWeeksToFilterSearchActive = React.useMemo(() => {
		const text = filterState.filterText;
		const prev = filterState.previousSearchText;
		const weeks = filterState.weeksToFilter;

		return (
			(text !== '' && weeks !== 0) ||
			(weeks === 0 && text === prev && text.trim() !== '')
		);
	}, [filterState.filterText, filterState.previousSearchText, filterState.weeksToFilter]);


	const getWeeksToFilterDropDown = React.useCallback((searchFilter) => {
		const selectedValue = Number(filterState.weeksToFilter ?? 0);

		return (
			<Select
				variant="standard"
				sx={{
					float: "right",
					zIndex: 1,
					mt: 1.25,
					mr: 1.25,
					width: 100,
					backgroundColor: "rgba(0, 140, 205, 0.12)",
					"&.Mui-focused": {
						backgroundColor: "rgba(0, 140, 205, 0.12)",
					},
				}}
				value={selectedValue}
				onChange={(e) => {
					weeksToFilter_changeHandler({
						e: { ...e },
						target: { ...e.target },
						currentTarget: { dataset: { searchFilter: searchFilter } }
					});
				}}
			>
				<MenuItem value={0}>No Filter</MenuItem>
				<MenuItem value={1}>1 Week</MenuItem>
				<MenuItem value={2}>2 Weeks</MenuItem>
				<MenuItem value={4}>5 Weeks (1 Month)</MenuItem>
				<MenuItem value={9}>9 Weeks (2 Months)</MenuItem>
				<MenuItem value={26}>26 Weeks (6 Months)</MenuItem>
				<MenuItem value={52}>52 Weeks (1 Year)</MenuItem>
			</Select>
		);
	}, [filterState])

	const weeksToFilter_changeHandler = (event) => {
		const storedText = getFilter([...baseSessionPath, 'searchText']) || '';
		const rawStoredWeeks = getFilter([...baseSessionPath, 'weeksToFilter']);
		const storedWeeks = rawStoredWeeks === '' ? '' : parseInt(rawStoredWeeks, 10);

		const weeksToFilter = parseInt(event.target.value, 10);
		const prevWeekToFilter = filterState.weeksToFilter;
		const isNoFilter = weeksToFilter === 0;
		const shouldStoreFilterText = (prevWeekToFilter === 0 && storedText === '' && storedWeeks === '');

		if (filterState.filterText !== '') {
			setFilter([...baseSessionPath, "weeksToFilter"], weeksToFilter);

			if (shouldStoreFilterText) {
				setFilter([...baseSessionPath, "searchText"], filterState.filterText);

			}
		} else {
			setFilter([...baseSessionPath, "weeksToFilter"], '');

		}
		filterDispatch({ payload: { weeksToFilter: weeksToFilter, isServerMode: isNoFilter } });
	};

	const getSearchButton = React.useCallback(() => {

		if (filterState.weeksToFilter === 0) {
			return (
				<MUIButton
					color="primary"
					size="medium"
					startIcon={<SearchIcon />}
					sx={{
						backgroundColor: '#008ecd',
						border: '1px solid #008ecd',
						borderRadius: '6px',
						color: 'white !important',
						fontSize: '0.8rem !important',
						fontFamily: 'Lato, sans-serif',
						cursor: 'pointer',
						marginTop: '10px',
						marginRight: '14px',
						marginLeft: '1px',
						marginBottom: '0px',
						paddingTop: '4px',
						paddingBottom: '5px',
						paddingLeft: '11px',
						paddingRight: '9px',
						width: '100px',
						textTransform: 'none',
						'&:hover': {
							backgroundColor: '#007cb5',
							borderColor: '#007cb5',
						}
					}}
					text="Search"
					onClick={() => {

						if (filterState.filterText !== '') {
							setFilter([...baseSessionPath, 'searchText'], filterState.filterText);
							setFilter([...baseSessionPath, 'weeksToFilter'], filterState.weeksToFilter);
						} else {
							setFilter([...baseSessionPath, 'searchText'], '');
							setFilter([...baseSessionPath, 'weeksToFilter'], '');
						}

						fetchArchivedInvoices(filterState.filterText, filterState.weeksToFilter);
					}}
				/>
			);
		}

		return null;
	}, [filterState])


	const archiveStatusHandler = useCallback(
		async (invoiceDocument, inProgressFn = () => { }, successCallback) => {
			const invoiceDocumentId = invoiceDocument?.invoiceDocumentId;

			if (!invoiceDocumentId) {
				toast.error('Invalid invoice document.');
				return;
			}

			const payload = {
				invoiceDocumentId: invoiceDocumentId,
				isArchive: invoiceDocument.isArchive,
				modelDefId: invoiceDocument.modelDefId
			};

			const isUnarchiving = invoiceDocument.isArchive === 'Y';

			inProgressFn(true);

			try {
				await httpPost('/api/InvoiceDocument/changearchivestatus', payload);
				toast.success(`Invoice successfully ${isUnarchiving ? 'unarchived' : 'archived'}`);
				if (typeof successCallback === 'function') {
					successCallback();
				}

			} catch (error) {
				toast.error(`Failed to ${isUnarchiving ? 'unarchive' : 'archive'} invoice.
					Error: ${error?.response?.data?.message}
				`);
			} finally {
				inProgressFn(false);
			}
		},
		[] // no dependencies — function is stable forever
	);

	const viewClickHandler = React.useCallback((event) => {
		event.preventDefault();
		var rowData = getRowData(parseInt(event.target.dataset.rowid, 10));
		setViewRowData(rowData);
		setMode(event.target.dataset.mode);
		setOpenInvoiceDocumentEditorDialog(true);
	}, [viewData])

	const getRowData = React.useCallback((value) => {
		var rowData = viewData.data;
		return rowData[rowData.findIndex(d => d.invoiceDocumentId === value)];
	}, [viewData])

	const getUnarchiveLink = React.useCallback((row) => {
		const invoiceDocumentId = row.invoiceDocumentId;
		return (viewData.hasUnarchivePermission && row.isArchive === Constants.YES_FLAG ?
			<> / <Link data-rowid={invoiceDocumentId} href="#" onClick={async (e) => {
				e.preventDefault();
				var rowData = getRowData(parseInt(e.target.dataset.rowid, 10));
				setViewRowData(rowData);
				setConfirmationDialogOpen(true);
			}}>Unarchive</Link></> : <></>)
	}, [viewData, mainGridRef?.current])


	const getActionLinks = React.useCallback((rowData) => {
		const row = rowData.row;
		const invoiceDocumentId = row.invoiceDocumentId;
		return (<><div>
			<Link data-rowid={invoiceDocumentId} data-mode={Constants.ARCHIVE} href="#" onClick={viewClickHandler}>View</Link>
			{getUnarchiveLink(row)}
		</div>
		</>)
	}, [viewData])

	const invoiceDocumentEditor_closeHandler = React.useCallback(({ invoiceDocumentId }) => {
		setOpenInvoiceDocumentEditorDialog(false);
		setViewRowData({});
		setMode(null)
		if (invoiceDocumentId > 0) {
			fetchArchivedInvoices(filterState.filterText, filterState.weeksToFilter);
		}
	}, [filterState])

	const getVisibleRowIds = () => {
		const allRowIds = mainGridRef.current.getAllRowIds();
		const filterText = filterState.filterText?.toLowerCase();

		if (!filterText) return allRowIds;

		return allRowIds.filter((id) => {
			const row = mainGridRef.current.getRow(id);
			return Object.values(row).some(val =>
				String(val || '').toLowerCase().includes(filterText)
			);
		});
	};

	const exportColumns = React.useMemo(() => {
		return getColumns(modelDefId);
	}, [modelDefId]);

	// New UI: the Invoices list's column order and sizes (redesign/lists/invoiceList.js); Classic gets its columns as they are.
	const newUi = isNewUi();
	const archiveColumns = columns => (newUi ? arrangeListColumns(columns, 'archive', {
		dateFormatter: { format: d => d.toLocaleDateString('en-US') }, dateTimeFormatter: { format: formatDate }
	}) : columns);

	return (
		<div>
			<h1>Archived {modelDefName[modelDefId]} Invoice Documents</h1>
			<div className="form-group">


				<div style={{ display: 'block', overflow: 'auto', width: '100%' }} className={newUi ? 'apw2-archive' : undefined}>
					<EnhancedDataGrid
						rows={viewData.data}
						disableColumnMenu
						pagination
						title=""
						gridRef={mainGridRef}
						pageSize={10}
						isWeeksToFilterSearchActive={isWeeksToFilterSearchActive}
						sortModel={filterState.sortModel}
						onSortModelChange={(model) => {
							filterDispatch({ payload: { sortModel: model } });
							setFilter([getInvoiceModuleName(modelDefId), 'ArchivedInvoiceDocuments', 'sortModel'], model);
						}}
						setFilterText={(text) => {
							const isNoFilter = filterState.weeksToFilter === 0;
							const prevText = filterState.filterText;
							filterDispatch({ payload: { filterText: text } });

							const shouldFilterPersist = (
								(text !== '' && !isNoFilter) || (prevText === text && text !== '' && isNoFilter)
							);

							if (shouldFilterPersist) {
								setFilter([...baseSessionPath, "searchText"], text);
								setFilter([...baseSessionPath, "weeksToFilter"], filterState.weeksToFilter);
							} else {
								setFilter([...baseSessionPath, "searchText"], '');
								setFilter([...baseSessionPath, "weeksToFilter"], '');
							}
						}}
						filterText={filterState.filterText}
						{...serverProps}
						searchCallback={null}
						showSearchTooltip={false}
						footerMessage={''}
						columns={archiveColumns([
							...(modelDefId !== 3 ? [
								{
									headerName: 'File Name',
									field: 'fileName',
									flex: 1,
									renderCell: (rowData) => {
										const { invoiceDocumentId, invoiceDocumentFileLocation, invoiceDocumentStatusId, fileName } = rowData.row;
										const isDownloading = downloadingInvoices[invoiceDocumentId];

										if (isDownloading) {
											return (
												<div
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
														width: '100%',
														height: '100%',
													}}
												>
													<CircularProgress size={18} />
												</div>
											);
										}

										if (!invoiceDocumentFileLocation) {
											return fileName || '';
										}

										//return (
										//	<Link
										//		href="#"
										//		onClick={(e) => {
										//			e.preventDefault();
										//			e.stopPropagation();
										//			handleDownloadFile(modelDefId, invoiceDocumentId, invoiceDocumentFileLocation);
										//		}}
										//	>
										//		{fileName}
										//	</Link>
										//);

										return (
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 8,
												}}
											>
												<span
													role="button"
													tabIndex={0}
													style={{
														display: 'flex',
														alignItems: 'center',
														cursor: 'pointer',
													}}
													onClick={(e) => {
														e.preventDefault();
														e.stopPropagation();
														handleDownloadFile(modelDefId, invoiceDocumentId, invoiceDocumentFileLocation);
													}}
												>
													<Tooltip title="View">
														{getFileIcon(invoiceDocumentFileLocation)}

													</Tooltip>

												</span>

												<span>{fileName}</span>
											</div>
										);
									}
								}
							] : []),
							...(modelDefId === 3 ? [
								{
									headerName: 'Media Type',
									field: 'mediaType',
									flex: 1
								}
							] : []),
							{
								headerName: 'Processed Date',
								field: 'processedDate',
								type: 'datetime',
								valueFormatter: ({ value }) => value && formatDate(value),
								valueGetter: ({ value }) => value && new Date(value),
								flex: 1
							},
							...(modelDefId !== 3 ? [
								{
									headerName: 'Client',
									field: 'clientNameCode',
									flex: 1,
									renderCell: rowData => {


										const rawValue = rowData.row.clientNameCode || '';


										const clients = rawValue.split('|').filter(c => c.trim());
										const tooltipText = rawValue;


										const displayText = clients.length > 1 ? `${clients[0]}...` : clients[0];

										return (
											<Tooltip
												title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipText}</span>}
												placement="top"
												arrow
											>
												<span style={{
													whiteSpace: 'normal',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													display: 'inline-block',
													maxWidth: '100%',
													fontSize: '0.75rem'
												}}>
													{displayText}
												</span>
											</Tooltip>
										);
									}
								}
							] : []),
							...(modelDefId === 3 ? [
								{
									headerName: 'Advertiser/Product',
									field: 'advertiserProduct',
									flex: 1,
								}
							] : []),
							...(modelDefId !== 3 ? [
								{
									headerName: 'ERP Vendor/Site',
									field: 'vendorCodeName',
									flex: 1
								}
							] : []),
							...(modelDefId === 3 ? [
								{
									headerName: 'Vendor',
									field: 'payTo',
									flex: 1
								}
							] : []),
							{
								headerName: 'Status',
								field: 'status',
								renderCell: rowData =>
									<div>
										{rowData.row.status}
										<Tooltip key={rowData.row.rowId} title={rowData.row.invoiceDocumentPostingErrorMessage ? rowData.row.invoiceDocumentPostingErrorMessage : ""}>
											<ErrorIcon key={rowData.row.rowId + '_i'} style={{
												float: "right", display: rowData.row.invoiceDocumentStatusId === 180
													//|| (rowData.row.invoiceDocumentPostingErrorMessage
													//&& rowData.row.invoiceDocumentStatusId === 50)
													? "" : "none"
											}} color="secondary" />
										</Tooltip>
									</div>,
								flex: 1
							},
							{
								headerName: 'Invoice #',
								field: 'invoiceNumber',
								flex: 1
							},
							...(modelDefId === 3 ? [
								{
									headerName: 'Total Spots',
									field: 'totalSpot',
									type: 'number',
									align: 'right',
									headerAlign: 'right',
									renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{toNumberWithNoDecimalPlaces(rowData.row.totalSpot)}</span>,
									flex: 1
								}
							] : []),
							{
								headerName: 'Net Amount',
								field: 'netAmount',
								type: 'currency',
								align: 'right',
								headerAlign: 'right',
								renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.netAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
								flex: 1
							},
							{
								headerName: 'Tax Amount',
								field: 'taxAmount',
								type: 'currency',
								align: 'right',
								headerAlign: 'right',
								renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.taxAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
								flex: 1
							},
							{
								headerName: 'Total Invoice Amount',
								field: 'totalInvoiceAmount',
								type: 'currency',
								align: 'right',
								headerAlign: 'right',
								renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.totalInvoiceAmount) + " " + defaultStringIfNullOrEmpty(rowData.row.currencyCode, "")}</span>,
								flex: 1
							},
							{
								headerName: 'Due Date',
								field: 'dueDate',
								type: 'date',
								valueGetter: ({ value }) => value && new Date(value),
								flex: 1
							},
							...(modelDefId === 3 ? [
								{
									headerName: 'Invoice Date',
									field: 'invoiceDate',
									type: 'date',
									valueGetter: ({ value }) => value && new Date(value),
									flex: 1
								}
							] : []),
							...(modelDefId === 3 ? [
								{
									headerName: 'File Name',
									field: 'invoiceDocumentFileLocation',
									valueGetter: ({ value, row }) => {
										if (value?.toLowerCase().indexOf('.pdf') === -1) {
											return value;
										}
										else {
											return row.fileName;
										}

									},
									flex: 1
								}
							] : []),
							{
								headerName: 'Actions',
								field: 'actions',
								align: 'center',
								headerAlign: 'center',
								renderCell: rowData => getActionLinks(rowData),
								flex: 1
							}

						])}
						getRowId={(row) => row.rowId}
						disableSelectionOnClick
						options={{
							pageSize: 10,
							pageSizeOptions: [10, 20, 30, 40, 50],
							maxBodyHeight: 670,
							exportButton: true,
							exportFileName: "ArchivedInvoices"
						}}
						customcomponent={<>
							{getWeeksToFilterDropDown(filterState.filterText)}
							{getSearchButton()}
						</>}
						data={viewData.data}
						exportServerCallback={() => {
							// Wait a tick to ensure DataGrid's internal filter is applied
							setTimeout(() => {
								const visibleRowIds = getVisibleRowIds();
								const filteredDataRows = viewData.data
									.filter(item => visibleRowIds.includes(item.rowId))
									.map(e => e.invoiceDocumentId);

								fetchArchivedInvoiceReport(modelDefId, filteredDataRows.join(','));
							}, 0);
						}
						}
						serverExport={true}
					/>
				</div>
			</div>
			{
				openInvoiceDocumentEditorDialog &&
				<Dialog open={openInvoiceDocumentEditorDialog} TransitionComponent={Transition} fullScreen>
					<InvoiceDocumentEditor info={{
						rowData: viewRowData,
						mode: mode,
						inProgress: inProgress,
						modelDefId: modelDefId
					}} clientInfo={{
						rowData: viewRowData,
						mode: mode,
						inProgress: inProgress,
						modelDefId: modelDefId
					}} onClose={invoiceDocumentEditor_closeHandler} fetchDashboard={(gadgetNo, weeks) => { }} />
				</Dialog>
			}
			{
				<GenericMessageDialog
					open={confirmationDialogOpen}
					onClose={() => { }}
					message={'Are you sure, you want to unarchive the invoice?'}
					acceptCallback={async () => {
						await archiveStatusHandler({ ...viewRowData, modelDefId: modelDefId }, inProgress, () => {
							setConfirmationDialogOpen(false);
							setViewRowData({});
							//mainGridRef?.current?.updateRows([{ id: row.rowId, _action: 'delete' }]);
						});
						fetchArchivedInvoices(filterState.filterText, filterState.weeksToFilter)
					}}
					type={'confirm'}
					rejectCallback={() => { setConfirmationDialogOpen(false) }}
				/>
			}
			{
				exportState.tempTableEnabled ?

					<ServerExportWrapper
						rows={exportState.exportData}
						columns={exportColumns}
						options={{
							exportFileName: `Archived${modelDefName[modelDefId]}Invoices`
						}}
						dataLoaded={exportState.dataLoaded}
						getRowId={(row) => row.rowId}
						resetStates={() => {
							setExportState({
								payload: {
									tempTableEnabled: false,
									dataLoaded: false,
									exportData: []
								}
							})
						}}
					/>
					:
					<></>
			}
		</div>
	);
};

// #endregion old component

const getColumns = (modelDefId) => {
	const cellStyle = { paddingLeft: 8, paddingRight: 45 };
	const filterCellStyle = { textAlign: 'right', paddingRight: 45 };
	const headerStyle = { textAlign: 'right' };
	const columns = [
		{
			headerName: 'Vendor Code',
			field: 'vendorCode',
			width: 100, hideable: false
		},
		{
			headerName: 'Vendor Name',
			field: 'vendorName',
			width: 120, hideable: false
		}
		//,
		//{
		//	headerName: 'Site Id',
		//	field: 'siteId',
		//	width: 250
		//},
	];
	if (modelDefId === 3) {
		columns.push(
			{
				headerName: 'Source',
				field: 'invoiceSource',
				valueGetter: ({ value }) => value == "1" ? "EDI" : "PDF",
				width: 100
			});
	}
	columns.push({
		headerName: 'File Name',
		field: 'invoiceDocumentFileLocation',
		width: 200,
		valueGetter: rowData => {
			if (rowData.row.invoiceSource && rowData.row.invoiceSource == 1)
				return rowData.row.invoiceDocumentFileLocation;

			if (rowData.row.invoiceDocumentFileLocation) {
				return rowData.row.invoiceDocumentFileLocation.split('_').slice(1).join('_');
			}
			return rowData.row.invoiceDocumentFileLocation;
		}
	},
		{
			headerName: 'Invoice Number',
			field: 'invoiceNumber',
			width: 100
		});
	if (modelDefId === 2) {
		columns.push(
			{
				headerName: 'PO Code',
				field: 'poCode',
				width: 100
			});
	}
	if (modelDefId === 3) {
		columns.push(
			{
				headerName: 'Advertiser/Product',
				field: 'advertiserProduct',
				width: 150
			});
	}
	columns.push(
		{
			headerName: 'Status',
			field: 'invoiceDocumentStatus',
			//type: 'singleSelect',
			//valueOptions: lookupFilter,
			filterCellStyle: { width: 40, maxWidth: 40 },
			width: 120
		},
		{
			headerName: 'Assigned To',
			field: 'assignedTo',
			filterCellStyle: { width: 40, maxWidth: 40 },
			renderCell: rowData => {
				if (rowData.row.assignedTo && rowData.row.assignedTo.split('|').length > 1)
					return <div>
						<Tooltip
							title={
								<span style={{ whiteSpace: 'pre-line' }}>{rowData.row.assignedTo.split('|').join("\n")}</span>
							}>
							<Link>{rowData.row.assignedTo.split('|')[0]} ...</Link>
						</Tooltip>
					</div>;
				return rowData.row.assignedTo;
			},
			width: 130
		},
		{
			headerName: 'Invoice Date',
			field: 'invoiceDate',
			type: 'date',
			valueGetter: ({ value }) => value && new Date(value),
			width: 100
		},
		{
			headerName: 'Due Date',
			field: 'dueDate',
			type: 'date',
			valueGetter: ({ value }) => value && new Date(value),
			width: 100
		},
		{
			headerName: 'Payment Term',
			field: 'paymentTermCode',
			width: 100
		});
	if (modelDefId !== 2) {
		columns.push(
			{
				headerName: 'Service Term From',
				field: 'serviceTermStartDate',
				type: 'date',
				valueGetter: ({ value }) => value && new Date(value),
				width: 100
			},
			{
				headerName: 'Service Term To',
				field: 'serviceTermEndDate',
				type: 'date',
				valueGetter: ({ value }) => value && new Date(value),
				width: 100
			});
	}
	if (modelDefId === 2) {
		columns.push({
			headerName: 'Customer Code',
			field: 'clientCode',
			width: 100
		},
			{
				headerName: 'Customer Name',
				field: 'clientName',
				width: 120
			});
	}
	columns.push(
		{
			headerName: 'Currency',
			field: 'currencyCode',
			width: 80
		});
	if (modelDefId !== 2) {
		//columns.push(
		//	{
		//		headerName: 'Client Code',
		//		field: 'clientCode',
		//		width: 100
		//	},
		//	{
		//		headerName: 'Client Name',
		//		field: 'clientName',
		//		width: 120
		//	}
		//);
		columns.push(
			{
				headerName: 'Client',
				field: 'clientCodeName',
				width: 120
			}
		);
		if (modelDefId === 1) {
			columns.push(
				{
					headerName: 'Project Code',
					field: 'level2',
					width: 150
				}
			);
		}

		if (modelDefId !== 3) {
			columns.push(
				{
					headerName: 'Campaign Name',
					field: 'description',
					width: 150
				},
			);
		}
		if (modelDefId === 1) {
			columns.push(
				{
					headerName: 'Media Plan Name',
					field: 'mediaPlanName',
					width: 150
				}
			)
		}
		if (modelDefId !== 3) {
			columns.push(
				{
					headerName: 'IO/PO Number',
					field: 'ioNumber',
					width: 120
				}
			)
		}

		// columns.push({
		//     headerName: 'IO/PO Description',
		//     field: 'ioDescription',
		//     width: 250
		// });
	}
	if (modelDefId === 2) {
		columns.push(
			{
				headerName: 'Project',
				field: 'level2Key',
				width: 120
			},
			{
				headerName: 'Project Desc.',
				field: 'description',
				width: 150
			},
			{
				headerName: 'Activity',
				field: 'level3Key',
				width: 100
			},
			{
				headerName: 'Expense Type',
				field: 'rTypeName',
				width: 100
			},
			{
				headerName: 'Quantity',
				field: 'quantity',
				type: 'numeric',
				valueGetter: ({ value }) => (value && Number(value)) || 0,
				width: 80,
				align: 'right',
				headerAlign: 'right'
			}
		);
	}

	columns.push(
		{
			headerName: modelDefId === 2 ? 'Amount' : 'Invoice Net Amount',
			field: 'ioInvoiceAmount',
			type: 'currency',
			cellStyle: cellStyle,
			filterCellStyle: filterCellStyle,
			headerStyle: headerStyle,
			valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
			width: 100,
			align: 'right',
			headerAlign: 'right'
		}
	);

	if (modelDefId !== 3) {
		columns.push(
			{
				headerName: 'Discount Amount',
				field: 'discountAmount',
				type: 'currency',
				cellStyle: cellStyle,
				filterCellStyle: filterCellStyle,
				headerStyle: headerStyle,
				valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
				width: 100,
				align: 'right',
				headerAlign: 'right'
			}
		);
	}
	if (modelDefId === 2) {
		columns.push(
			{
				headerName: 'Net Cost',
				field: 'netCost',
				type: 'currency',
				cellStyle: cellStyle,
				headerStyle: headerStyle,
				filterCellStyle: filterCellStyle,
				valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
				//renderCell: rowData => formatNumber(rowData.row.netCost),
				width: 100,
				align: 'right',
				headerAlign: 'right'
			},
			//{
			//	headerName: 'Consumed Amount',
			//	field: 'matchToDateNet',
			//	type: 'currency',
			//	cellStyle: cellStyle,
			//	headerStyle: headerStyle,
			//	filterCellStyle: filterCellStyle,
			//	valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
			//	//renderCell: rowData => formatNumber(rowData.row.matchToDateNet),
			//	width: 100,
			//	align: 'right',
			//	headerAlign: 'right'
			//},
			//{
			//	headerName: 'Remaining Amount',
			//	field: 'remainingAmount',
			//	type: 'currency',
			//	cellStyle: cellStyle,
			//	headerStyle: headerStyle,
			//	filterCellStyle: filterCellStyle,
			//	valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
			//	//renderCell: rowData => formatNumber(rowData.row.remainingAmount),
			//	width: 100,
			//	align: 'right',
			//	headerAlign: 'right'
			//}
		);
	}

	columns.push(
		{
			headerName: 'Total Invoice Amount',
			field: 'totalInvoiceAmount',
			type: 'currency',
			cellStyle: cellStyle,
			filterCellStyle: filterCellStyle,
			headerStyle: headerStyle,
			valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
			width: 100,
			align: 'right',
			headerAlign: 'right'
		}
	);
	//if (modelDefId === 1) {
	//	//columns.push(
	//		//{
	//		//	headerName: 'IO/PO Amount',
	//		//	field: 'poAmount',
	//		//	type: 'currency',
	//		//	cellStyle: cellStyle,
	//		//	headerStyle: headerStyle,
	//		//	filterCellStyle: filterCellStyle,
	//		//	valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
	//		//	//renderCell: rowData => formatNumber(rowData.row.poAmount),
	//		//	width: 100,
	//		//	align: 'right',
	//		//	headerAlign: 'right'
	//		//},
	//		//{
	//		//	headerName: 'Consumed Amount',
	//		//	field: 'consumedAmount',
	//		//	type: 'currency',
	//		//	cellStyle: cellStyle,
	//		//	headerStyle: headerStyle,
	//		//	filterCellStyle: filterCellStyle,
	//		//	valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
	//		//	//renderCell: rowData => formatNumber(rowData.row.consumedAmount),
	//		//	width: 100,
	//		//	align: 'right',
	//		//	headerAlign: 'right'
	//		//},
	//		{
	//			headerName: 'Delivery Amount',
	//			field: 'deliveryAmount',
	//			type: 'currency',
	//			cellStyle: cellStyle,
	//			headerStyle: headerStyle,
	//			filterCellStyle: filterCellStyle,
	//			valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
	//			//renderCell: rowData => formatNumber(rowData.row.deliveryAmount),
	//			width: 100,
	//			align: 'right',
	//			headerAlign: 'right'
	//		});
	//}
	columns.push(
		{
			headerName: 'Tax Amount',
			field: 'taxAmount',
			type: 'currency',
			cellStyle: cellStyle,
			headerStyle: headerStyle,
			filterCellStyle: filterCellStyle,
			valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
			width: 100,
			align: 'right',
			headerAlign: 'right'
		});
	//if (state.taxSetting === 2) {
	columns.push({
		headerName: 'Tax Amt based on Vendor',
		field: 'vendorTaxAmounts',
		type: 'currency',
		cellStyle: cellStyle,
		headerStyle: headerStyle,
		filterCellStyle: filterCellStyle,
		valueGetter: ({ value }) => (value && formatNumber(value)) || "0.00",
		width: 100,
		align: 'right',
		headerAlign: 'right'
	},
		{
			headerName: 'Tax Diff.',
			field: 'taxAmounts',
			type: 'currency',
			cellStyle: cellStyle,
			headerStyle: headerStyle,
			filterCellStyle: filterCellStyle,
			valueGetter: ({ value, row }) => {
				return formatNumber((row.taxAmount || 0) - (row.vendorTaxAmounts || 0));
			},
			width: 100,
			align: 'right',
			headerAlign: 'right'
		});
	//}

	columns.push(
		//{
		//	headerName: 'Transaction Id',
		//	field: 'transactionId',
		//	width: 100
		//},
		{
			headerName: 'Upload Date',
			field: 'uploadDate',
			type: 'date',
			valueGetter: ({ value }) => value && new Date(value),
			width: 100
		},
		//{
		//	headerName: 'Posted Date',
		//	field: 'invoiceDocumentPostingUpdateDate',
		//	type: 'date',
		//	valueGetter: ({ value }) => value && new Date(value),
		//	width: 100
		//},
	);
	columns.push(
		{
			headerName: 'Actions',
			field: 'actions',
			align: 'center',
			width: '150px',
			headerAlign: 'center',
			disableExport: true,
			renderCell: rowData => getActionLinks(rowData),
			flex: 1
		})
	return columns;
}


export default ArchivedInvoiceDocument;